import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100 transition";

  return (
    <div className="min-h-screen grid place-items-center bg-slate-100 p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 p-8 shadow-sm" data-testid="forgot-page">
        <h1 className="font-display font-black text-slate-900 text-2xl">Reset your password</h1>
        {sent ? (
          <div className="mt-4">
            <p className="text-slate-600" data-testid="forgot-success">If that email exists, a reset link has been generated. Check the server logs for the link (email provider not configured for v1).</p>
            <Link to="/admin/login" className="mt-6 inline-flex items-center gap-2 text-green-700 font-semibold"><ArrowLeft className="h-4 w-4" /> Back to login</Link>
          </div>
        ) : (
          <>
            <p className="text-slate-500 mt-2">Enter your email and we'll generate a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="info@speedexgardencare.co.uk" data-testid="forgot-email" />
              {error && <p className="text-sm text-red-600">{error}</p>}
              <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-green-600 px-6 py-3 font-bold text-white hover:bg-green-700 disabled:opacity-60" data-testid="forgot-submit">
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Send reset link"}
              </button>
            </form>
            <Link to="/admin/login" className="mt-5 inline-flex items-center gap-2 text-slate-500 hover:text-slate-700 text-sm"><ArrowLeft className="h-4 w-4" /> Back to login</Link>
          </>
        )}
      </div>
    </div>
  );
}
